import React from 'react';

const Hot = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.8301 15.7952C21.5896 12.6633 20.1314 10.7007 18.845 8.96873C17.6538 7.36535 16.625 5.98075 16.625 3.93825C16.625 3.77419 16.5331 3.62423 16.3874 3.54905C16.2413 3.47342 16.0657 3.48581 15.9329 3.58236C14.0009 4.96483 12.3889 7.29489 11.8258 9.5181C11.4348 11.0659 11.3831 12.806 11.3759 13.9552C9.59168 13.5741 9.18751 10.9053 9.18325 10.8762C9.17338 10.808 9.14763 10.7431 9.10807 10.6867C9.06852 10.6303 9.01627 10.584 8.95553 10.5515C8.83121 10.4866 8.68507 10.4819 8.55903 10.5443C8.46547 10.5895 6.26257 11.7089 6.13439 16.178C6.12541 16.3267 6.125 16.4758 6.125 16.6249C6.125 20.9667 9.65788 24.4993 14 24.4993C14.006 24.4998 14.0124 24.5006 14.0175 24.4993H14.0231C18.3545 24.4869 21.875 20.959 21.875 16.6249C21.875 16.4065 21.8301 15.7952 21.8301 15.7952ZM14 23.6244C12.5525 23.6244 11.375 22.3701 11.375 20.8283C11.375 20.7757 11.3746 20.7227 11.3784 20.6578C11.3959 20.0076 11.5194 19.5637 11.6548 19.2685C11.9087 19.8136 12.3624 20.3148 13.0994 20.3148C13.1568 20.3148 13.2137 20.3035 13.2668 20.2815C13.3199 20.2596 13.3682 20.2273 13.4088 20.1867C13.4495 20.1461 13.4817 20.0978 13.5037 20.0448C13.5256 19.9917 13.5369 19.9348 13.5369 19.8773C13.5369 19.2544 13.5497 18.5358 13.7048 17.8873C13.8428 17.3123 14.1726 16.7005 14.5905 16.21C14.7763 16.8466 15.1387 17.3618 15.4924 17.8647C15.9987 18.5841 16.5221 19.3279 16.614 20.5963C16.6195 20.6715 16.6251 20.7471 16.6251 20.8283C16.625 22.3701 15.4475 23.6244 14 23.6244Z",
      fill: "#FF7400"
    }
  )
);

export { Hot };
//# sourceMappingURL=Hot.js.map
